<template lang="pug">
	.creative-dashboard
		Dashboard
		CreateNewOrder
		CreateNewCampaign
		OrderActionsDelete
		OrderActionsEdit
		ActiveStatusConfirmationPopup
		ShowCampaign
		CampaignActionsDelete
		CampaignActionsEdit
		DatePicker
</template>

<script>
	import Dashboard from './components/Dashboard/Dashboard'
	import CreateNewOrder from "@/components/Pages/PagesActions/CreateNewOrder";
	import OrderActionsDelete from "@/components/Pages/OrderActions/OrderActionsDelete";
	import OrderActionsEdit from "@/components/Pages/OrderActions/OrderActionsEdit";
	import CreateNewCampaign from "@/components/Pages/PagesActions/CreateNewCampaign";
	import ShowCampaign from "@/components/Pages/PagesActions/ShowCampaign";
	import CampaignActionsDelete from "@/components/Pages/CampaignActions/CampaignActionsDelete";
	import DatePicker from "@/components/CustomControls/DatePicker";
	import CampaignActionsEdit from "@/components/Pages/CampaignActions/CampaignActionsEdit";
	import ActiveStatusConfirmationPopup from "@/components/Pages/ActiveStatusConfirmationPopup";

	export default {
		name: 'app',
		components: {
			ActiveStatusConfirmationPopup,
			CampaignActionsEdit,
			DatePicker,
			CampaignActionsDelete,
			ShowCampaign,
			CreateNewCampaign,
			OrderActionsEdit,
			OrderActionsDelete,
			CreateNewOrder,
			Dashboard
		},
		data() {
			return {

			}
		},
		created() {

		}
	}
</script>

<style lang="sass">
	//air datepicker styles
	@import '~air-datepicker/air-datepicker.css'
	// CoreUI Icons Set
	@import '~@coreui/icons/css/coreui-icons.min.css'
	/* Import Font Awesome Icons Set */
	$fa-font-path: '~font-awesome/fonts/'
	@import '~font-awesome/scss/font-awesome.scss'
	/* Import Simple Line Icons Set */
	$simple-line-font-path: '~simple-line-icons/fonts/'
	@import '~simple-line-icons/scss/simple-line-icons.scss'
	/* Import Flag Icons Set */
	@import '~flag-icon-css/css/flag-icon.min.css'
	/* Import Bootstrap Vue Styles */
	@import '~bootstrap-vue/dist/bootstrap-vue.css'
	// Import Main styles for this application
	@import 'assets/scss/style'

	*
		margin: 0
		padding: 0

	body
		background-color: #2f353a
		width: 100%
		height: 100%
		position: fixed
		top: 0
		left: 0
		overflow: hidden

		>.creative-dashboard
			height: 100%

	fieldset
		border: none

</style>
